import { Link } from "react-router-dom";

export function BrandMark({ compact = false }: { compact?: boolean }) {
  return (
    <Link to="/" className="focus-ring inline-flex items-center gap-3 rounded-full">
      <span className="grid size-11 place-items-center rounded-full border border-ktd-gold/50 bg-ktd-rich text-lg font-black text-ktd-softGold shadow-gold">
        K
      </span>
      {!compact && (
        <span className="leading-tight">
          <span className="block font-display text-xl font-bold text-white">Kreatethedate</span>
          <span className="block text-xs font-semibold uppercase tracking-[0.18em] text-ktd-softGold">
            Memory Media Vault
          </span>
        </span>
      )}
    </Link>
  );
}
